import React, {useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Gallery.css'; // We'll create this next
import img1 from '../Components/Images/inst11.png'
import img4 from '../Components/Images/inst12.jpg'
import img5 from '../Components/Images/inst14.jpg'
import img6 from '../Components/Images/inst15.avif'
import img7 from '../Components/Images/inst15.jpeg'
// import img8 from '../Components/Images/inst9.jpg'
// import img9 from '../Components/Images/inst10.jpg'
import img10 from '../Components/Images/banner/inst1.jpeg'
import img11 from '../Components/Images/inst/ai_inst.jpg'
import img12 from '../Components/Images/inst/eas_inst.jpg'
import img13 from '../Components/Images/inst/esl_inst.jpg'
import img14 from '../Components/Images/inst/5.jpg'

const Gallery = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    // const [showModal, setShowModal] = useState(false);
  // Sample gallery data (replace with your actual images)
  const galleryItems = [
    {
      id: 1,
      imageUrl: img11,
      title: 'Ai Weighing Scale',
      description: 'Ai Enabled Weighing'
    },
    {
      id: 2,
      imageUrl: img10,
      title: 'EAS Systems',
      description: 'Security Solutions'
    },
    {
      id: 3,
      imageUrl: img1,
      title: 'Retail Weighing Scales',
      description: ''
    },
    {
      id: 4,
      imageUrl: img4,
      title: 'Portable POS',
      description: 'with receipt and scanner'
    },
    {
      id: 5,
      imageUrl: img12,
      title: 'EAS antitheft antenna',
      description: 'EAS antenna installation'
    },
    {
      id: 6,
      imageUrl: img6,
      title: 'Barcode scanners',
      description: 'Handheld barcode scanner'
    },
    {
      id: 7,
      imageUrl: img13,
      title: 'Electronic Shelf Labels',
      description: 'ESL installation'
    },
    {
      id: 8,
      imageUrl: img14,
      title: 'Electronic Shelf Labels',
      description: 'ESL on promotion time'
    }
  ];
  const openModal = (item) => {
    setSelectedImage(item);
    document.body.classList.add('modal-open');
  };

  const closeModal = () => {
    setSelectedImage(null);
    document.body.classList.remove('modal-open');
  };

  return (
    <section className="gallery-section py-5" style={{ backgroundColor: '#f8f9fa' }}>
      <div className="container">
        <div className="section-title text-center mb-5">
          <h3 className="display-5 fw-bold"
          style={{
                        background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                        WebkitBackgroundClip: "text",
                        backgroundClip: "text",
                        color: "transparent",
                        display: "inline-flex",
                        alignItems: "center",
                        textDecoration: "none",
                        marginTop: "auto",
                        fontFamily:"Poppins"
                      }}
          >Our Gallery</h3><br/>
          <p className="lead text-muted"
          style={{
                        background: "linear-gradient(135deg, #0A6E54 0%,rgb(27, 246, 49) 100%)",
                        WebkitBackgroundClip: "text",
                        backgroundClip: "text",
                        color: "transparent",
                        display: "inline-flex",
                        alignItems: "center",
                        textDecoration: "none",
                        marginTop: "auto",
                        fontFamily:"Poppins"
                      }}
          >Explore our collection of beautiful moments</p>
        </div>
        
        <div className="row g-4">
          {galleryItems.map((item) => (
            <div key={item.id} className="col-md-6 col-lg-4 col-xl-3">
              <div className="gallery-item" onClick={() => openModal(item)}>
                <img 
                  src={item.imageUrl} 
                  alt={item.title} 
                  className="img-fluid rounded"
                />
                <div className="gallery-overlay">
                  <div className="overlay-content">
                    <h5 className="text-white">{item.title}</h5>
                    <p className="text-white">{item.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Modal for expanded view */}
        {selectedImage && (
        <div className="image-modal">
          <div className="modal-backdrop" onClick={closeModal}></div>
          <div className="modal-container">
            <button className="close-button" onClick={closeModal}>
              <span>&times;</span>
            </button>
            <img 
              src={selectedImage.imageUrl} 
              alt={selectedImage.title} 
              className="enlarged-image"
            />
          </div>
        </div>
      )}
      </div>
    </section>
  );
};

export default Gallery;